import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "d-flex" }

import type { QuotesSlider } from '@/types';
import { computed, ref, watch } from 'vue';
import { VSlideGroup } from 'vuetify/lib/components/index.mjs';

type Props = {
  items: QuotesSlider;
  title: string;
  contentCenter: boolean;
};

const BUTTON_SIZE = 36;


export default /*@__PURE__*/_defineComponent({
  __name: 'SliderComponent',
  props: {
    items: {},
    title: {},
    contentCenter: { type: Boolean }
  },
  setup(__props: any) {



const sliderRef = ref<InstanceType<typeof VSlideGroup> | null>(null);
const isScrolled = computed<boolean>(() => Boolean(sliderRef.value?.scrollOffset && sliderRef.value.scrollOffset > 0));

// Toggle blur
watch(isScrolled, (value) => {
    const sliderComponent = document.querySelector<HTMLDivElement>('.slider-component');
    if (!sliderComponent) return;
    const slideGroupContainer = sliderComponent.querySelector<HTMLDivElement>('.v-slide-group__container');
    if (!slideGroupContainer) return;
    const sliderContent = value ? 'none' : '\'\'';
    slideGroupContainer.style.setProperty('--sliderContent', sliderContent);
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_slide_group_item = _resolveComponent("v-slide-group-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    "no-gutters": "",
    class: "slider-component"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createElementVNode("h2", {
            class: _normalizeClass(["f-24 sz-white--text font-weight-medium mb-0 py-3", { 'text-center': _ctx.$vuetify.display.mdAndUp }])
          }, _toDisplayString(_ctx.title), 3)
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_sheet, {
                      width: "350",
                      "min-width": "350",
                      elevation: "4",
                      rounded: "",
                      color: "white",
                      class: "sz-primary-grey--text font-weight-medium mx-3 d-none d-lg-block"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: require('@/assets/images/quotesSlider/1.jpg?as=webp&w=350&h=260'),
                          class: "rounded"
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(VSlideGroup), {
                      ref_key: "sliderRef",
                      ref: sliderRef,
                      "center-active": "",
                      class: _normalizeClass({ 'content-center': _ctx.contentCenter })
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (n, index) => {
                          return (_openBlock(), _createBlock(_component_v_slide_group_item, { key: index }, {
                            default: _withCtx(({ toggle }) => [
                              _renderSlot(_ctx.$slots, "default", {
                                id: index,
                                item: n,
                                toggle: toggle
                              })
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      prev: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          height: BUTTON_SIZE,
                          width: BUTTON_SIZE,
                          color: "white",
                          icon: "$chevronLeft",
                          variant: "flat"
                        })
                      ]),
                      next: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          height: BUTTON_SIZE,
                          width: BUTTON_SIZE,
                          color: "white",
                          icon: "$chevronRight",
                          variant: "flat"
                        })
                      ]),
                      _: 3
                    }, 8, ["class"])
                  ])
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})